module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "confirm-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "confirm",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "confirm-wrapper"
  }, [_c('div', {
    staticClass: "confirm-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-btn left",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelBtnText))]), _vm._v(" "), _c('div', {
    staticClass: "operate-btn",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmBtnText))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-098b964b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/confirm/confirm.vue
// module id = 564
// module chunks = 1